import { useOrgContext } from 'components/OrgContextProvider';
import React from 'react';

export default function OrgContextSelector() {
	const ctx = useOrgContext();

	const isSystemAdmin = ctx?.availableTenants?.some(t => t.id === 'system') ?? false;
	const regularTenants = (ctx?.availableTenants ?? []).filter(t => t.id !== 'system');

	// // Auto-select the first tenant for non-system-admins when no tenant is selected
	// React.useEffect(() => {
	// 	if (!isSystemAdmin && !ctx?.tenantID && regularTenants.length > 0) {
	// 		ctx?.setTenantID(regularTenants[0].id);
	// 		ctx?.setWorkspaceID(regularTenants[0].workspaces?.[0]?.id || null);
	// 	}
	// // eslint-disable-next-line react-hooks/exhaustive-deps
	// }, [isSystemAdmin, ctx?.tenantID, ctx?.availableTenants]);

	const handleTenantChange = (newTenantID: string) => {
		ctx?.changeContext(newTenantID || null, null);
	};

	const handleWorkspaceChange = (newWorkspaceID: string) => {
		ctx?.changeContext(ctx?.tenantID || null, newWorkspaceID || null);
	};

	if (!ctx?.tenantID && ctx?.availableTenants && ctx?.availableTenants?.length > 0 && !ctx?.availableTenants?.find(t => t.id === 'system')) {
		ctx.changeContext(ctx.availableTenants[0].id, ctx.availableTenants[0].workspaces?.[0]?.id || null);
	}

	return (
		<div className="org-context-selector">
			{regularTenants.length > 0 || isSystemAdmin ? (
				<div>
					<div style={{ fontSize: '70%' }}>Tenant</div>
					<div>
						<select
							value={ctx?.tenantID || ''}
							onChange={(e) => handleTenantChange(e.target.value)}
						>
							{isSystemAdmin && <option value="">(System)</option>}
							{regularTenants.map(tenant => (
								<option key={tenant.id} value={tenant.id}>{tenant.name}</option>
							))}
						</select>
					</div>
				</div>
			) : <span>No tenants available</span>}

			{ctx?.tenantID && regularTenants.length > 0 && (
				<div>
					<div style={{ fontSize: '70%' }}>Workspace</div>
					<div>
						<select
							value={ctx.workspaceID || ''}
							onChange={(e) => handleWorkspaceChange(e.target.value)}
						>
							<option value="">(No Workspace)</option>
							{regularTenants.find(t => t.id === ctx?.tenantID)?.workspaces?.map(workspace => (
								<option key={workspace.id} value={workspace.id}>{workspace.name}</option>
							))}
						</select>
					</div>
				</div>
			)}

			<div style={{ fontSize: '60%', marginLeft: '0.5rem', marginTop: '0.5rem' }}>
				<div><span style={{ color: '#888' }}>Context Path:</span> {ctx?.contextPath}</div>
				<div><span style={{ color: '#888' }}>App Path:</span> {ctx?.appPath}</div>
			</div>
		</div>
	);
}
